import { Slider } from '../controls/Slider';
import { useUi, type Tool } from '../../state/ui';

/** Brush size / feather / flow, shared by the mask brush, heal, skin and clean whites (§11.4). */
export function BrushControls({ flow = true }: { flow?: boolean }) {
  const brush = useUi((s) => s.brush);
  const set = (p: Partial<typeof brush>) => useUi.getState().set({ brush: { ...brush, ...p } });
  return (
    <div>
      <Slider
        label="brushSize"
        testId="slider-brush-size"
        value={Math.round(brush.size * 1000) / 10}
        min={0.5}
        max={30}
        step={0.5}
        digits={1}
        defaultValue={5}
        onChange={(v) => set({ size: v / 100 })}
      />
      <Slider
        label="brushFeather"
        testId="slider-brush-feather"
        value={Math.round(brush.feather * 100)}
        min={0}
        max={100}
        step={1}
        defaultValue={50}
        onChange={(v) => set({ feather: v / 100 })}
      />
      {flow && (
        <Slider
          label="brushFlow"
          testId="slider-brush-flow"
          value={Math.round(brush.flow * 100)}
          min={1}
          max={100}
          step={1}
          defaultValue={100}
          onChange={(v) => set({ flow: v / 100 })}
        />
      )}
    </div>
  );
}

/** A toggle button that turns a viewer tool on and off. */
export function ToolButton({ tool, label, testId }: { tool: Tool; label: string; testId: string }) {
  const active = useUi((s) => s.tool === tool);
  return (
    <button
      aria-pressed={active}
      data-testid={testId}
      onClick={() => useUi.getState().set({ tool: active ? 'none' : tool })}
      style={{ marginBottom: 6, ...(active ? { background: 'var(--accent)', color: '#fff' } : {}) }}
    >
      {label}
    </button>
  );
}
